module.exports = __webpack_public_path__ + "archivist_badge_02.jpg?ccf0f36af6b411b16af308c7b0de5bdd";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge/archivist_badge_02.jpg
// module id = 377
// module chunks = 0